import { Component, OnInit, Input,OnDestroy,OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';

import { FechasService } from 'src/app/services/fechas/fechas';
import { ImprimiService } from 'src/app/services/imprimir/imprimirService';
import { FirmaService } from 'src/app/services/firma/firmaService';
import { estilos_informes } from 'src/app/config/estilos-informes';
import { logo } from 'src/app/config/imagenes';
import { ImageBaseService } from 'src/app/services/imagenes/imagenes.service';
import { url } from 'src/app/config/config';
import { getDocumento } from 'src/app/config/procedimientos_registros';


declare var $:any;



@Component({
  selector: 'app-imprimir-informe-cabecera',
  templateUrl: './imprimir-informe-cabecera.component.html',
  styleUrls: ['./imprimir-informe-cabecera.component.css'],
  providers:[ImprimiService,FirmaService]
  
})
export class ImprimirInformeCabeceraComponent implements OnInit,OnDestroy,OnChanges{
   
 


    @Input() title: string = '';
    @Input() id: string = '';
    @Input() database: string = '';
    @Input() field: string = '';
    @Input() fecha: string = '';
    @Input() procedimiento: string = '';
    @Input() numero_anexo: string = '';
 
   
    
    //public database:string = 'agua_cloro';


    public anexo = new Date();
    public productos:any = [];
    public oldId = '';
    public baseUrl = url + 'upload/firmas/';
    public logo: string = '';
    public rev: string = '';
    documento: any;
   
    constructor(
        private fechaService:FechasService,
        private imprimirService:ImprimiService,
        private firmaService : FirmaService,
        private ImageBaseService: ImageBaseService

        ){
            this.oldId = this.id;
            
    }

    ngOnInit(): void {
        this.logo = logo;
        
       this.mostrarContenido();
       let id_documento_registro = localStorage.getItem('id_documento_registro');
       if (id_documento_registro != null && id_documento_registro.length > 0 ) {
        this.documento = getDocumento(id_documento_registro);
        //console.log('log', this.documento);
        
        this.title = this.documento.title.toUpperCase() || 'INFORME';
        this.procedimiento = this.documento.procedimiento_num || ' X';
        this.numero_anexo = this.documento.registro_num || 'X';
       }
       
    }
    ngOnDestroy(): void {
        
    }
    ngOnChanges(changes: SimpleChanges) {
       // this.mostrarContenido();
       if(this.id){
        if(this.oldId != this.id ){
            this.mostrarContenido();
        }
      
       }else{

       }
        
    }

    mostrarContenido() {
       

        if ((this.fecha as string).substring(2,3) === '/' ) {            
           let auxFecha = this.fecha.split('/'); 
           this.fecha = auxFecha[2]+'-'+auxFecha[1]+'-'+auxFecha[0];
        }

        
        this.imprimirService.getAnexo(this.fecha, this.field ).subscribe(( resp: any ) => {
            //console.log('anexo cabecera', resp);
                // console.log('anexo cabecera', resp);
                /* console.log('this.mostrarContenido()', resp[0]['fecha_anexo']);
                console.log('resp[0][rev]', resp[0]['rev']);  */
                
                try {
                       
                if( resp[0]['fecha_anexo'] === undefined ){
                    this.anexo = new Date();
                }else{
                    this.anexo = resp[0]['fecha_anexo'];
                }
                } catch (error) {
                    this.anexo = new Date();
                }
                
                 try {
                       
                if( resp[0]['rev'] === undefined ){
                    this.rev = 'X';
                }else{
                    
                    
                    this.rev = resp[0]['rev'];
                }
                } catch (error) {
                    this.rev = 'X';
                }
                
                 
                
               });
       
     
    }
jsUcfirst(string) 
{
    return string.charAt(0).toUpperCase() + string.slice(1);
}





}
  
